import { StringHelper } from "../../../../utils/helpers";
import { DrawerTemplateButton, DrawerActionButtonProps } from './drawerTemplateButton';
import { DrawerHeader, DrawerTitle } from "..";
import { DrawerHeaderProps } from "../drawerHeader";

export interface DrawerTemplateHeaderProps extends DrawerHeaderProps {
    title?: string;
    buttons?: DrawerActionButtonProps[]
}

export const DrawerTemplateHeader: React.FC<DrawerTemplateHeaderProps> = (props) => {
    const buttons = (): DrawerActionButtonProps[] => {
        if (props.buttons === null || props.buttons === undefined || props.buttons.length <= 0) {
            return [];
        }

        return props.buttons.filter(item => item.onClick !== null && item.onClick !== undefined)
    }

    if (buttons().length <= 0 && StringHelper.isNullOrEmpty(props.title)) {
        return null;
    }

    return (
        <DrawerHeader {...props}>
            <div className="container-fluid d-flex justify-content-between ps-1 pe-0 py-0">
                <DrawerTitle>{props.title}</DrawerTitle>
                {buttons() && (
                    <div>
                        {buttons().map((item: DrawerActionButtonProps, index: number) => (
                            <DrawerTemplateButton key={"drawer_header_button_" + index} {...item} />
                        ))}
                    </div>
                )}
            </div>
        </DrawerHeader>
    );
};